import { SelectedFeatureInfo } from "../SelectedFeatureInfo";
import { Map } from "ol";
import ImageWMSEx from "../net/ImageWMSEx";
import { ILayerFactory } from "./ILayerFactory";
import ImageLayer from "ol/layer/Image";
import { MapContextMenuItem } from "../MapContextMenuItem";
import { LayerUtil } from "../util/LayerUtil";

/**
 * 最大ズームレベル
 */

const LAYER_MAX_ZOOMLEVEL = 18;

/**
 * 最小ズームレベル
 */

const LAYER_MIN_ZOOMLEVEL = 9;

/**
 * API通信用URL
 */
const URL_API = process.env.VUE_APP_XROAD_API_URL;

/**
 * 特車通行許可不要区間_交差点レイヤ出力クラス
 */
export class SpecialVehicleExemptPointLayerFactory implements ILayerFactory {
  /**
   * 表示WMSレイヤ
   */
  private _wmsLayer: ImageLayer<ImageWMSEx>;

  /**
   * 表示WMSソース
   */
  private _wmsImageSource: ImageWMSEx;

  /**
   * 地物属性の有無を取得
   */
  isFeatureInfo(): boolean {
    return true;
  }

  /**
   * 範囲地物属性の有無を取得
   */
  isRangeFeatureInfo(): boolean {
    return true;
  }

  /**
   * 右クリック処理の有無を取得
   */
  isRightClickInfo(): boolean {
    return false;
  }

  /**
   * レイヤ定義を取得
   * @param map openLayers Mapクラス
   */
  getViewLayer(_map?: Map): ImageLayer<ImageWMSEx>[] {
    if (this._wmsLayer) {
      return [this._wmsLayer];
    }
    //WMSレイヤの取得
    this._wmsImageSource = new ImageWMSEx({
      url: URL_API,
      params: {
        LAYERS: "t_special_vehicle_exempt_xpoint",
        EXCEPTIONS: "application/json",
      },
      ratio: 1,
      serverType: "geoserver",
      crossOrigin: "Anonymous",
    });
    this._wmsLayer = new ImageLayer({
      source: this._wmsImageSource,
      maxZoom: LAYER_MAX_ZOOMLEVEL,
      minZoom: LAYER_MIN_ZOOMLEVEL,
    });
    return [this._wmsLayer];
  }

  /**
   * 地物情報を取得
   * @param map 地図
   * @param layerNames レイヤ名リスト
   * @param latitude クリック座標緯度
   * @param longitude クリック座標経度
   * @param x クリック位置X
   * @param y クリック位置Y
   * @param width 地図幅
   * @param height 地図高さ
   * @param bBox 地図範囲（BBOX)
   * @param currentTime 対象時間
   */
  async getFeatureInfo(
    map: Map,
    _latitude: number,
    _longitude: number
  ): Promise<SelectedFeatureInfo[]> {
    if (
      map.getView().getZoom() > LAYER_MAX_ZOOMLEVEL ||
      map.getView().getZoom() <= LAYER_MIN_ZOOMLEVEL
    ) {
      return null;
    }
    return null;
  }

  /**
   * 指定範囲の地物情報を取得
   * @param map 地図
   * @param bBox 地図範囲（BBOX)
   */
  async getRangeFeatureInfo(): Promise<SelectedFeatureInfo[]> {
    return null;
  }

  /**
   * 地物属性の有無を取得
   */
  async getRightClickInfo(): Promise<MapContextMenuItem[]> {
    return null;
  }

  /**
   * レイヤの表示状態を設定
   * @param isVisible 表示有無
   * @param isBold 太線表示
   */
  setVisible(isVisible: boolean) {
    if (isVisible) {
      this._wmsImageSource.updateParams({
        LAYERS: "t_special_vehicle_exempt_xpoint",
        EXCEPTIONS: "application/json",
      });
    }
    this._wmsLayer.setVisible(isVisible);
  }

  /**
   * 表示中のレイヤ数を取得
   */
  getVisibleLayerCount() {
    return this._wmsLayer?.getVisible() ? 1 : 0;
  }

  /**
   * 表示レイヤが存在するか判定
   */
  isVisibleLayer(_map:Map) {
    return LayerUtil.isVisibleLayer(_map, this._wmsLayer)
  }
}
